import { getDynamicEnv } from '@/utils/configManager';

// Create a function that returns current dynamic environment
export async function getEnv() {
  const dynamicEnv = await getDynamicEnv();
  
  return {
    scheme: 'votesnow',
    apiHost: dynamicEnv.apiHost,
    cognitoClientId: dynamicEnv.cognitoClientId,
    cognitoUserPoolId: dynamicEnv.cognitoUserPoolId,
    associatedDomain: dynamicEnv.associatedDomain,
    environment: process.env['EAS_UPDATE_BRANCH'],
    // Add dynamic environment info
    currentUsername: dynamicEnv.currentUsername,
    isReviewMode: dynamicEnv.isReviewMode,
    androidAppDownloadUrl: 'https://play.google.com/store/apps/details?id=now.votes.groundforce',
  } as const;
}

// Keep backward compatibility with static env object
// Note: This will use the configuration from when the module was first loaded
// For backward compatibility, we'll use default values for the static env object
const env = {
  scheme: 'votesnow',
  apiHost: process.env['EXPO_PUBLIC_API_HOST']!,
  cognitoClientId: process.env['EXPO_PUBLIC_COGNITO_CLIENT_ID']!,
  cognitoUserPoolId: process.env['EXPO_PUBLIC_COGNITO_USER_POOL_ID']!,
  associatedDomain: process.env['EXPO_PUBLIC_ASSOCIATED_DOMAIN']!,
  environment: process.env['EAS_UPDATE_BRANCH'],
  currentUsername: null,
  isReviewMode: false,
  androidAppDownloadUrl: 'https://play.google.com/store/apps/details?id=now.votes.groundforce',
} as const;

export { env };
export default env; 